<template>
  <div v-if="hasPromotionFilter" class="be-promotion-filter-chip">
    <span class="be-promotion-filter-chip__label">{{ $t('hotel.filter.promotion-applied') }}</span>
    <span v-if="promotionName" class="be-promotion-filter-chip__value">{{ promotionName }}</span>
    <button
      type="button"
      class="be-promotion-filter-chip__clear be-press"
      aria-label="Clear promotion filter"
      @click="$emit('clear')">
      <svg width="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.8 6.21L17.39 4.8L11.8 10.39L6.21 4.8L4.8 6.21L10.39 11.8L4.8 17.39L6.21 18.8L11.8 13.21L17.39 18.8L18.8 17.39L13.21 11.8L18.8 6.21Z" fill="currentColor" />
      </svg>
    </button>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'BePromotionFilterChip',
    computed: {
      ...mapGetters({
        promotionFilterId: 'getBePromotionFilterId',
        promotionName: 'getBePromotionFilterName'
      }),
      hasPromotionFilter() {
        return this.$isNotEmptyV2(this.promotionFilterId);
      }
    }
  };
</script>

<style scoped>
.be-promotion-filter-chip {
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--merchant-primary-color, #79a33a);
  border-radius: var(--be-v3-button-radius, 8px);
  background: #fff;
  font-size: 0.875rem;
  line-height: 1.4;
}
.be-promotion-filter-chip__label {
  flex-shrink: 0;
  color: #777;
}
.be-promotion-filter-chip__value {
  font-weight: 600;
  color: #1a1a2e;
  min-width: 0;
  /* the guest must read the full promo name, so long names wrap instead of truncating */
  overflow-wrap: anywhere;
}
.be-promotion-filter-chip__clear {
  display: flex;
  flex-shrink: 0;
  margin-top: 3px;
  margin-left: 4px;
  padding: 0;
  border: none;
  background: transparent;
  color: #222;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/BePromotionFilterChip.vue